import { InputActionMeta } from 'react-select';

export function shouldForwardTypeaheadInput(
  action: InputActionMeta['action']
): boolean {
  return action === 'input-change' || action === 'set-value';
}
